module.exports = __webpack_public_path__ + "img/blog2.24dd080e.jpg";